<template>
  <el-dialog
    title="Timeslot collection configuration"
    :visible.sync="objectFormVisible"
    width="75%"
    class="vb-object-config-dialog"
    @close="onResetForm">
    <div v-if="timeslotCollectionId">
      <TimeslotCollectionConfig
        @deleted="onTimeslotCollectionDeleted"
        :timeslot_collection="timeslotCollection"
        :timeslot_collection_id="timeslotCollectionId" />
    </div>
  </el-dialog>
</template>

<script>
import TimeslotCollectionConfig from '@/components/Config/Legacy/TimeslotCollectionConfig';

export default {
  data: () => ({
    isNewObject: true,
    timeslotCollectionId: null,
    objectFormVisible: false,
  }),
  computed: {
    timeslotCollection() {
      return this.timeslotCollectionId
             ? this.$models.timeslotCollection.getNode( this.timeslotCollectionId )
             : null;
    },

  },
  methods: {
    showNewModal() {
      this.isNewObject = true;
      this.timeslotCollectionId = null;
      this.objectFormVisible = true;
    },

    showUpdateModal({ timeslotCollectionId }) {
      console.log("showUpdateModal", timeslotCollectionId);
      this.isNewObject = false;
      this.timeslotCollectionId = timeslotCollectionId;
      this.objectFormVisible = true;
    },

    onResetForm() {
      this.isNewObject = null;
      this.timeslotCollectionId = null;
      this.objectForm  = null;
    },

    onTimeslotCollectionDeleted() {
      console.log("todo - not implemented");
    }
  },
  components: {
    TimeslotCollectionConfig
  }
}
</script>
